import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  CREATE_IMPORT_DOCUMENT,
  CREATE_IMPORT_DOCUMENT_FAILURE,
  CREATE_IMPORT_DOCUMENT_SUCCESS,
  CreateImportDocumentActionType
} from 'src/redux/importDocumentReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* CreateImportDocumentFlow(action: CreateImportDocumentActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = '/dealers_api/import_documents'
    const response: { pdf_url: string } = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: POST,
      params: {
        import_document: action.payload
      }
    })
    yield put(CREATE_IMPORT_DOCUMENT_SUCCESS({ pdf_url: response.pdf_url }))
  } catch (error) {
    yield put(CREATE_IMPORT_DOCUMENT_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* CreateImportDocumentSaga(): Generator<any, void, any> {
  yield takeLatest(CREATE_IMPORT_DOCUMENT, CreateImportDocumentFlow)
}
